export default "__VITE_ASSET__DSUTLyxb__"